import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  tree: { fontFamily: "monospace", fontSize: 12.5, lineHeight: 1.7 },
  row: { whiteSpace: "pre-wrap", wordBreak: "break-word" },
  toggle: { cursor: "pointer", userSelect: "none", color: theme.app.dark },
  key: { color: "#5F3DC4" },
  count: { color: theme.app.textTertiary },
  str: { color: "#1E7E34" },
  num: { color: "#0B7285" },
  bool: { color: "#B26A00" },
  null: { color: theme.app.textTertiary },
}));

const Primitive = ({ value, classes }) => {
  if (value === null || value === undefined)
    return <span className={classes.null}>null</span>;
  if (typeof value === "string") return <span className={classes.str}>"{value}"</span>;
  if (typeof value === "number") return <span className={classes.num}>{value}</span>;
  if (typeof value === "boolean")
    return <span className={classes.bool}>{String(value)}</span>;
  return <span>{String(value)}</span>;
};

const Node = ({ k, value, depth, classes }) => {
  const isObj = value && typeof value === "object";
  const [open, setOpen] = useState(depth < 1);
  const pad = { paddingLeft: depth * 14 };

  if (!isObj) {
    return (
      <div className={classes.row} style={pad}>
        {k !== undefined && <span className={classes.key}>{k}: </span>}
        <Primitive value={value} classes={classes} />
      </div>
    );
  }

  const entries = Array.isArray(value)
    ? value.map((v, i) => [i, v])
    : Object.entries(value);
  const brace = Array.isArray(value) ? `[${entries.length}]` : `{${entries.length}}`;

  return (
    <div>
      <div className={classes.row} style={pad}>
        <span className={classes.toggle} onClick={() => setOpen(o => !o)}>
          {open ? "▾" : "▸"} {k !== undefined ? <span className={classes.key}>{k} </span> : null}
          <span className={classes.count}>{brace}</span>
        </span>
      </div>
      {open &&
        entries.map(([ck, cv]) => (
          <Node key={ck} k={ck} value={cv} depth={depth + 1} classes={classes} />
        ))}
    </div>
  );
};

const JsonTree = ({ data, rootKey = "event" }) => {
  const classes = useStyles();
  return (
    <div className={classes.tree}>
      <Node k={rootKey} value={data} depth={0} classes={classes} />
    </div>
  );
};

export default JsonTree;
